
export const SocialMediaControl = [
  
    {
        name: "facebook",
        label: "Link Facebook"
    },
    {
        name: "instagram",
        label: "Link Instagram"
    },

    {
        name: "youtube",
        label: "Link Youtube"
    },
    {
        name: "blog",
        label: "Link Blog/Site"
    },
    {
        name: "tiktok",
        label: "Link TikTok"
    }
  
]